import BulkAddToWishlistFlow, {
  type BulkAddToWishlistFlowProps,
} from "~/features/orders/orderDetails/components/AddToWishlist/BulkAddToWishlistFlow";
import { useDispatch } from "react-redux";
import { addOrderDetailsToWishlistThunk } from "~/features/wishlist/redux/wishlistSlice";
import { type OrderLineItemData } from "~/domains/orders/types/modelsV2";

type SelfProps = Pick<BulkAddToWishlistFlowProps, "onClose"> & {
  selectedOrderItems: OrderLineItemData[];
};

export const OrderDetailsAddToWishlistFlow = ({ onClose, selectedOrderItems }: SelfProps) => {
  const dispatch = useDispatch();

  const handleAddToWishlist = (data: { wishlistId: string } | { wishlistName: string }) => {
    return dispatch(addOrderDetailsToWishlistThunk(data, selectedOrderItems));
  };

  return <BulkAddToWishlistFlow onClose={onClose} onAddToWishlist={handleAddToWishlist} />;
};

export default OrderDetailsAddToWishlistFlow;
